import React, { useEffect, useState } from 'react';

import { iaRa } from 'lib/helpers/utility';

import Input from 'components/shared/Input/Input';

import UserList from './UserList';

const PracticeUsers = ({ members, isOpen, selectedUser, setSelectedUser }) => {
  const [search, setSearch] = useState('');
  const [filteredMembers, setFilteredMembers] = useState([]);

  useEffect(() => {
    setFilteredMembers(
      iaRa(members).filter((m) =>
        `${m.f_name} ${m.l_name}`.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, members]);

  useEffect(() => {
    if (!isOpen) setSearch('');
  }, [isOpen]);

  return (
    <>
      <div className="px-4 pt-3">
        <Input
          icon="search-linear"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          inputWrapperClassName="!bg-transparent !h-10"
        />
      </div>
      <UserList
        users={filteredMembers}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
      />
    </>
  );
};

export default PracticeUsers;
